import { useState, useEffect } from "react";
import { jsx } from "react/jsx-runtime";
import Home from "./Home";
import About from "./About";
import Contact from "./Contact";
import VBR from "./VBR";
import SlideShow from "./SlideShow";
import { BrowserRouter as Router, Route, Routes,} from "react-router-dom";
import Discography from "./Discography";


function App() {
  return (
    

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/vbr" element={<VBR />} />
        <Route path="/discography" element={<Discography />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

  );
}
export default App;